<template>
  <div>
    <div class="form-group">
      <!-- <label for="">Volumen</label> -->
      <div class="btn-group">
        <button 
          class="btn btn-secondary" 
          @click="volume = 1" 
          :class="{'active': volume == 1}">Unidad</button>
        <button 
          class="btn btn-secondary" 
          @click="volume = 2" 
          :class="{'active': volume == 2}">Paquete</button>
      </div>
    </div>
    <!-- <div class="form-group">
      <label for="">Precio</label>
      <app-input-money :quantity.sync="price" :selCurrDis="true"
        :moneyCode="money_code"
      ></app-input-money>
    </div> -->

    <div class="form-group">
      <label for="">Cantidad</label>
      <!-- <app-paginate ref="page" @change="quantity = $event"></app-paginate> -->
      <app-input-integer v-model="quantity"></app-input-integer>
    </div>

    <div class="form-group">
      <label for="">Codigo Producto</label>
      <SelectorByCode @product="save($event)" ref="sel"></SelectorByCode>
    </div>
  </div>
</template>

<script>
import SelectorByCode from "../../store-module/products/SelectorByCode";
import { LogisticService } from '../service';

export default {
  components: {
    SelectorByCode
  },
  props: {
    output_id: {},
    money_code: {}
  },
  data: () => ({
    price: undefined,
    volume: 1,
    quantity: 0
  }),
  mounted() {
    // this.$refs.page.setPageOptions({
    //   current_page: 1,
    //   total: 100,
    //   per_page: 1
    // });
  },
  methods: {
    reset() {
      // this.price = undefined;
      this.$refs.sel.reset();
      this.$refs.sel.focus();
      this.quantity = 0;
      // this.$refs.page.setPageOptions({
      //   current_page: 1,
      //   total: 100,
      //   per_page: 1
      // });
    },
    save(product) {
      this.$emit('preoutput');
      
      LogisticService.saveOutputDetail({
        output_id: this.output_id,
        product_id: product.id,
        quantity: this.volume == 1 ? this.quantity : this.quantity*product.units_by_packs
      }).then(() => { this.$emit('submitted'); });
    }
  }
}
</script>

<style>

</style>
